import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  private pageSource = new BehaviorSubject<string>("home");
  currentPage = this.pageSource.asObservable();

  private mobileMenuState = new BehaviorSubject<boolean>(false);
  mobileMenu = this.mobileMenuState.asObservable();

  private loadingStatus = new BehaviorSubject<boolean>(false);
  dataLoading = this.loadingStatus.asObservable();

  constructor() { }

  changePage(page: string) {
    this.pageSource.next(page);
  }

  toggleMobileMenu(state: boolean){
    this.mobileMenuState.next(state);
  }

  isLoading(status: boolean){
    this.loadingStatus.next(status);
  }
}
